import './main.css';
import Layout from 'utils/layout';
import Video from 'utils/video';
import 'utils/createSwatches';

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = new Layout();

  const sectionImports = sectionNames.map((name) => import(/* webpackChunkName: "[request]" */ `./${name}/index.js`)
    .then((m) => {
      const module = m.default;
      const modules = [...sections].filter(
        (section) => section.dataset.section === name,
      );
      modules.forEach((element) => {
        const dataEl = element.querySelector('[data-section-data]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : {};
        const videoEls = element.querySelectorAll('[data-component="video"]');
        const videos = videoEls
            && [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout }),
            );
        module(element, { ...data, layout, videos });
      });
    })
    .catch(console.error));

  // Open all external links in new tabs.
  [...document.links].forEach((link) => {
    if (link.hostname != window.location.hostname) link.target = '_blank';
  });

  // Import and initialize Alpine if it is found anywhere on the page
  if (document.querySelector('[x-data]') !== null) {
    Promise
      .all(sectionImports)
      .then(() => {
        import('alpinejs')
          .then(({ default: Alpine }) => {
            window.Alpine = Alpine;

            Alpine.start();
          });
      });
  }
})();
